export const specialitesData = [
  {
    name: "Tartare de thon",
    description: "Thon frais mariné, avocat, sésame et sauce soja",
    price: "2 800",
    category: "Entrée",
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/2ee3f0c79937f52a31ec2306ed0f9a6c.png"
  },
  {
    name: "Magret de canard au miel",
    description: "Magret rôti, sauce miel et épices, frites maison",
    price: "3 500",
    category: "Plat",
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/599c94dabc84b4b0e0b9354d5cda3d8e.png"
  },
  {
    name: "Mahi mahi crème vanille",
    description: "Poisson du jour, sauce vanille, légumes de saison",
    price: "3 200",
    category: "Plat",
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/b383d202c46047e5489161f755ed40e8.png"
  }
];